import { render, staticRenderFns } from "./ChannelLayout.vue?vue&type=template&id=6d47909f&scoped=true&"
import script from "./ChannelLayout.vue?vue&type=script&lang=js&"
export * from "./ChannelLayout.vue?vue&type=script&lang=js&"
import style0 from "./ChannelLayout.vue?vue&type=style&index=0&id=6d47909f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d47909f",
  null
  
)

export default component.exports